import React, { useId } from 'react'
import { Form } from 'react-bootstrap'

function Field({ labelText, type = 'text', placeholder = 'none', name, inputChangeHandler, onEnterHandler }) {
    const formfieldId = useId()
    return (
        <Form.Group className='form-white mb-3' controlId={formfieldId} >
            <Form.Label>{labelText}</Form.Label>
            <Form.Control onKeyDown={onEnterHandler} type={type} name={name} onChange={inputChangeHandler} placeholder={placeholder} />
        </Form.Group>
    )
}

export default Field